// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgVisibilityIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 4C4 4 1 10 1 12s3 8 11 8 11-6 11-8-3-8-11-8m5 8a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
  </g>
);
export default SvgVisibilityIcon;
SvgVisibilityIcon.displayName = 'SvgVisibilityIcon';
